import React from 'react';
import { SafeAreaProvider } from 'react-native-safe-area-context';

import { createNativeStackNavigator } from '@react-navigation/native-stack';

import { InviteFriendsScreen } from '@/feature/invite-friends/screens/InviteFriendsScreen';
import { screenPresets } from '@/navigation/screen-presets';
import { InviteFriendsStackParamList } from '@/navigation/types';
import { common } from '@/styles/styles';

const Stack = createNativeStackNavigator<InviteFriendsStackParamList>(); //type should adjust

type InviteFriendsStackProps = {
    /** Set when the stack is a tab, where there is nothing to navigate back to. */
    hideNavigationButton?: boolean;
};

export const InviteFriendsStack = ({ hideNavigationButton = false }: InviteFriendsStackProps) => {
    return (
        <SafeAreaProvider style={common.flex}>
            <Stack.Navigator screenOptions={screenPresets.modalStack}>
                <Stack.Screen
                    name="InviteFriends"
                    component={InviteFriendsScreen}
                    initialParams={{ hideNavigationButton }}
                />
            </Stack.Navigator>
        </SafeAreaProvider>
    );
};
